import React from 'react';
import Terminal from "./Terminal";
import { Box } from "@mui/material";

export default function Teaching({ innerRef }) {
    function teachingContent() {
        return (
            <>
                {/* Short Description */}
                <p style={{ color: "#1f1f1f", fontFamily: "RobotoRegular, sans-serif", fontSize: "17px", textAlign: "left" }}>
                    Overview of my teaching experience and collaborations with various institutions, focusing on Artificial Intelligence, Computer Vision, and more.
                </p>
                <ul style={{
                    color: "#1f1f1f",
                    fontFamily: "RobotoRegular, sans-serif",
                    fontSize: "17px",
                    listStyleType: "disc",
                    paddingLeft: "20px"
                }}>
                    <li>
                        <strong>From 2021</strong>: Teaching assistantship for the course of <em>Artificial Intelligence</em> (5 CFU),
                        Bachelor's Degree in Digital Engineering, Politecnico di Milano-ELIS (ING-INF/05).
                    </li>
                    <li>
                        <strong>From 2021</strong>: Teaching assistantship for the course of <em>Computer Vision</em> (9 CFU),
                        Master's degree in Engineering of Smart Systems, Department of Engineering, University Campus Bio-Medico of Rome (ING-INF/05).
                    </li>
                    <li>
                        <strong>From 2021</strong>: Teaching assistantship for the course of <em>Fundamentals of Artificial Intelligence</em> (9 CFU),
                        Master's degree in Engineering of Smart Systems, Department of Engineering, University Campus Bio-Medico of Rome (ING-INF/05).
                    </li>
                    <li>
                        <strong>2020-2022</strong>: Teaching assistantship for the course of <em>Fundamentals of Computer Science and C++</em> (10 CFU),
                        Bachelor degree in Computer Science – Digital Engineering program, ELIS – Politecnico di Milano (ING-INF/05).
                    </li>
                </ul>
            </>
        );
    }

    return (
        <Box ref={innerRef} display={'flex'} flexDirection={'column'} alignItems={'center'} mt={'3rem'} id={'teaching'}>
            <Terminal text={teachingContent()} />
        </Box>
    );
}
